/** This file is auto generated by convertSvgToJsx.ts */

import React from 'react'
const lightningstrike_medium = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M16.86 11.68a.938.938 0 0 0-.798-1.43h-3.187V2L6.139 12.947a.937.937 0 0 0 .799 1.428h3.187v8.25l6.735-10.946Z"
      clipRule="evenodd"
    />
  </svg>
)
export default lightningstrike_medium
